<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-01-13 14:37:26
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\MessageConfig\components\newMessageConfig.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-06-14 15:44:12
-->
<template>
  <normalDialog
    :title="$t('label_essweb_FlowTemplatesMessage_list_dialog_newConfigTitle')"
    :dialog="show"
    width="700"
    @close="closeDialog"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_FlowTemplatesMessage_list_dialog_templateLabel"
              :items="FlowTemplates"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.flow_template_uuid"
            >
            </AutoComplete>
          </v-col>

          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_FlowTemplatesMessage_list_dialog_sendtypeLabel"
              v-model="Data.message_type_uuid"
              :items="messageType"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              :rules="$GetRules(['_Require_Rules'], [null])"
              item-text="view_fields"
              item-value="value_field"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_FlowTemplatesMessage_list_dialog_templateStatusLabel"
              :items="Operating"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.operating_status"
            >
            </AutoComplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <AutoComplete
              isRequired
              label="label_essweb_FlowTemplatesMessage_list_dialog_sendObjectLabel"
              :items="sendObject"
              :readonly="!iSEdited"
              :filled="iSEdited"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              :rules="$GetRules(['_Require_Rules'], [null])"
              v-model="Data.send_object"
            >
            </AutoComplete>
          </v-col> </v-row></v-form
    ></template>
    <template v-slot:actions>
      <CardActions newBtn @new="toNew" @cancel="closeDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newFlowTemplatesMessage",
  props: {
    show: { default: false, type: Boolean },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    FlowTemplates() {
      return this.$getSelectTrans(this.FlowTemplatesData, "view_fields");
    },
    Operating() {
      return this.$getSelectTrans(this.OperatingData, "view_fields");
    },
    sendObject() {
      return this.$getSelectTrans(this.sendObjectData, "view_fields");
    },
    messageType() {
      return this.$getSelectTrans(this.messageTypeData, "view_fields");
    },
  },
  watch: {
    show(val) {
      if (!val) {
        this.Data = {
          flow_template_uuid: "",
          operating_status: "",
          send_object: "",
          message_type_uuid: "",
        };
      }
    },
  },
  data() {
    return {
      iSEdited: true,
      FlowTemplatesData: [],
      OperatingData: [],
      sendObjectData: [],
      messageTypeData: [],
      Data: {
        flow_template_uuid: "",
        operating_status: "",
        send_object: "",
        message_type_uuid: "",
      },
    };
  },
  mounted() {
    const that = this;
    this.getFlowTemplates();
    this.getOperating();
    this.getSendObject();
    this.getMessageType();
  },
  methods: {
    getOperating: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_operating_status",
      }).then((res) => {
        that.OperatingData = res.data;
      });
    },
    getSendObject: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_send_object",
      }).then((res) => {
        that.sendObjectData = res.data;
      });
    },
    getMessageType: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_send_msg_type",
      }).then((res) => {
        that.messageTypeData = res.data;
      });
    },
    getFlowTemplates: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_workflow_template_select",
      }).then((res) => {
        that.FlowTemplatesData = res.data;
      });
    },
    closeDialog: function () {
      this.$emit("close");
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("new", this.Data);
    },
  },
};
</script>